import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_EMPLOYEE);
var axios_instance_by_name = get_axios_instance(api_variables.SERVICE_EMPLOYEE_SEARCH_BY_NAME);
var axios_instance_by_le_and_name = get_axios_instance(api_variables.SERVICE_EMPLOYEE_BY_LE_AND_NAME);
var axios_instance_by_installation = get_axios_instance(api_variables.SERVICE_EMPLOYEE_INSTALLATION);
var axios_instance_salary_revision = get_axios_instance(api_variables.SERVICE_GET_SALARY_REVISION)
var axios_instance_taxoutside = get_axios_instance(api_variables.SERVICE_EMPLOYEE_TAXOUTSIDE_FETCH)
var axios_instance_taxoutsideedit = get_axios_instance(api_variables.SERVICE_EMPLOYEE_TAXOUTSIDE_EDIT)
var axios_instance_taxoutsidedelete = get_axios_instance(api_variables.SERVICE_EMPLOYEE_TAXOUTSIDE_DELETE)
var axios_instance_by_installmentPatch=get_axios_instance(api_variables.SERVICE_EMPLOYEE_INSTALLMENTPATCH);
var axios_instance_by_orgid_and_name = get_axios_instance(api_variables.SERVICE_GET_EMPLOYEE_BY_ORGID_NAME);

const _pk_name = "id";

const state = {
    entityWiseData: [],
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
    record: {}
};

const getters = {
    editMode: (state) => {
        return state.editMode;
    },
    record: (state) => {
        return state.record
    }
}

const mutations = {
    set: (state, payload) => {
        state.entityWiseData = payload
    },

    addEntity: (state, payload) => {
        // if(!state.entityWiseData[id]){
        // //console.log('payload add ', id)
        //   state.entityWiseData[id] = [...payload]
        // } else {
        // //console.log('payload add ', payload)
        //   state.entityWiseData[id].push(payload);
        // }
        state.entityWiseData.push(payload);
    },

    updateEntityById: (state, [payload]) => {
        for (let i = 0; i < state.entityWiseData.length; i++) {
            if (state.entityWiseData[i][_pk_name] === payload.id) {
                state.entityWiseData.splice(i, 1, payload);
            }
        }
    },

    removeEntityById: (state, [payload]) => {
        for (let i = 0; i < state.entityWiseData.length; i++) {
            if (state.entityWiseData[i][_pk_name] == payload) {
                state.entityWiseData.splice(i, 1);
            }
        }
        if (state.entityWiseData.length == 0)
            state.entityWiseData = []
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },
    setEditMode: (state, payload) => {
        state.editMode = payload.editMode;
        state.record = payload.record;
    }
}

const actions = {
    async fetchAll({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance.get(``, {
                params: {
                    ...payload
                }
            });
            commit("setFetching", false);
            if (res.status == 200) {
                commit("set", res.data.payload.data);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async fetchByName({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance_by_name.get('', {
                params: {
                    key: payload
                }
            });
            commit("setFetching", false);
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async fetchByNameInCurrentOrg({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance_by_orgid_and_name.get('', {
                params: {
                    org_id: payload.org_id,
                    name: payload.searchkey
                }
            });
            commit("setFetching", false);
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async fetchByLeAndName({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance_by_le_and_name.get('', {
                params: {
                    le_id: payload.le_id,
                    key: payload.key
                }
            });
            commit("setFetching", false);
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
  
    async fetchByInstallation({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance_by_installation.get('', {
                params: {
                    employee_id: payload.data.employee_id,
                    page:payload.data.page,
                    limit:payload.data.limit
                }
            });
            commit("setFetching", false);
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async fetchSalaryRevisionData({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance_salary_revision.get('', {
                params: {
                    le_id: payload.data.le_id,
                    page:payload.data.page,
                    limit:payload.data.limit
                }
            });
            commit("setFetching", false);
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    
    async fetchByTaxOutside({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance_taxoutside.get('', {
                params: {
                    employee_id: payload.data.employee_id,
                    page:payload.data.page,
                    limit:payload.data.limit
                }
            });
            commit("setFetching", false);
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async fectchEditTaxOutside({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance_taxoutsideedit.patch(`?content_id=${payload.content_id}&tax_amount=${payload.tax_amount}&month=${payload.month}&year=${payload.year}`
        );
            commit("setSaving", false);
            if (res.status == 200) {
                commit("editData", [res.data]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async deleteTaxtOutside({ commit },payload ) {
        try {
            commit("setDeleting", true);
            let res = await axios_instance_taxoutsidedelete.delete(`?content_id=${payload.content_id}`);
            console.log('ssss')
            commit("setDeleting", false);
            if (res.status == 200) {
                commit("setDeleting", payload);
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    
    async create({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.post("/", payload);
            commit("setSaving", false);
            if (res.status == 200) {
                commit("addEntity", [res.data]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async fetchByInstallationStatus({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance_by_installmentPatch.patch(`?employee_id=${payload.employee_id}&status=${payload.status}&schedule_code=${payload.schedule_code}`
        );
            commit("setSaving", false);
            if (res.status == 200) {
                commit("addStatus", [res.data]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async update({ commit }, [payload, id]) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.put(`/`, payload);
            commit("setSaving", false);
            if (res.status == 200) {
                commit("updateEntityById", [res.data, id]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async delete({ commit }, [payload, id]) {
        try {
            commit("setDeleting", true);
            let res = await axios_instance.delete(`/${payload.id}`);
            commit("setDeleting", false);
            if (res.status == 200) {
                commit("removeEntityById", [payload.id, id]);
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async changeEditMode({ commit }, payload) {
        try {
            commit("setEditMode", payload);
        } catch (error) {
            throw errorHandler(error.response);
        }
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};